exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animate__animated[data-v-5e17e886]{--animate-duration:1s;--animate-delay:2s}.overlay-slide[data-v-5e17e886]{background-color:var(--color-first-0-3,rgba(0,0,0,.3))}.overlay-slide[data-v-5e17e886]:hover{background-color:var(--color-first-0-5,rgba(0,0,0,.5))}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e17e886","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/ContentSlide.vue
// module id = 90
// module chunks = 13